import fetch from '../../utils/fetch'

export function checkNumberIsIn(params) {
    return fetch({
        url: '/api/parkrec/getUserInnerParking',
        method: 'GET',
        params
    })
}
